import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Portfolio from "./components/Portfolio";
import CV from "./components/CV";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
        <Route path="/" element={<Portfolio />}></Route>
        <Route path="/cv" element={<CV />}></Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
